export const FETCH_USER = 'user/FETCH_USER'
export const FETCH_USER_ERROR = `${FETCH_USER}_ERROR`
export const FETCH_USER_SUCCESS = `${FETCH_USER}_SUCCESS`

export const PATCH_USER = 'user/PATCH_USER'
export const PATCH_USER_ERROR = `${PATCH_USER}_ERROR`
export const PATCH_USER_SUCCESS = `${PATCH_USER}_SUCCESS`

export const SET_USE_LOCAL_CURRENCY = 'user/SET_USE_LOCAL_CURRENCY'
